function handleVideoPlay() {
    let button = document.querySelector(".video-play-icon")

    if (button) {
        button.addEventListener("click", function() {
            this.parentElement.classList.add("active")
            let video = this.parentElement.querySelector("video")
            if (video) {
                video.play()
                video.setAttribute("controls", "controls")
            }
        })
    }
}

export default handleVideoPlay